define('views/modules/dashboard/goal/goal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/events/layout-menu-events',
    // Views
    'views/parts/info-section',
    'views/modules/dashboard/goal/goal-content',
    // Templates
    'text!templates/modules/dashboard/goal/goal.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutMenuEvents,
    // Views
    VInfoSection,
    VGoalContent,
    // Templates
    TDashboardGoal
) {

    var VDashboardGoal = Backbone.View.extend({
        template: TDashboardGoal,

        regions: {
            content: ".goal-content",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.url = this.options.url;
            this.group = this.options.group;

            var view = this.view = {
                info: new VInfoSection({
                    title: "goal:Your goals",
                    content: this.template,
                    buttonTop: {
                        link: '#/' + this.url.goal,
                        text: 'goal:Show more goals',
                        displayIcon: false,
                        context: this,
                        callback: this.onShowMoreClick
                    }
                }),
                content: new VGoalContent({
                    model: this.model,
                    group: this.group,
                    url: this.url,
                })
            };

        },

        render: function() {

            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.content, zone.$content);

            return this;
        },

        onShowMoreClick: function() {
            LayoutMenuEvents.tabChange('goal');
        },

    });

    return VDashboardGoal;

});

